export default {
  GET_RESULT(state, payload) {
    state.Errors = payload;
  },

};
